// import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'press.my',
    path: 'P0101AuthorArticle/index',
    name: 'Author Home',
    component: () => import('./PgP0101AuthorPage')
  }
]
